<template>
    <div class="compose-chart-wrap">
        <div class="compose-chart" ref="compose"></div>
        <div class="k-line-tol poa">
            <span class="zjlx-time">{{curTime}}</span>
            <span>{{stockname}}</span>
            <span class="zjlx-kpj" v-show="open">开:
                <span :class="open>yc?'up':'down'">{{open}}</span>
            </span>
            <span class="zjlx-spj" v-show="close">收:
                <span :class="close>yc?'up':'down'">{{close}}</span>
            </span>
        </div>
        <div class="cjl-tol poa" v-show="cjl">
            成交量：<span style="color:#f2fa90;">{{cjl}}</span>
        </div>
        <div class="zjlr-tol poa" v-show="zjlr">
            陆港通资金流入：<span style="color:#f2fa90;">{{zjlr}}</span>
        </div>
        <div class="cg-detail-tol poa" v-show="cgl">
            <span style="color:#56b0f4;">持股量：<span>{{cgl}}</span></span>
            <span style="color:#f2fa90;margin-left:15px;">持股比例：<span>{{cgbl}}</span></span>
        </div>
    </div>
</template>

<script>
import event from '../event'
import { getComposeData } from '../../assets/js/action'
export default {
    data() {
        return {
            stockname: '',
            curTime: '',
            open: '',
            close: '',
            cjl: '',
            zjlr: '',
            cgl: '',
            cgbl: '',
            yc: '',
            statFlag: true,
        }
    },
    mounted() {
        this.getStockCode()
    },
    methods: {
        getStockCode() {
            event.subscribe('info', info => {
                this.curTime = ''
                this.open = ''
                this.close = ''
                this.cjl = ''
                this.zjlr = ''
                this.cgbl = ''
                this.cgl = ''
                let marketid = info.market || 'hs'
                getComposeData(info.code).then(data => {
                    if (info.market == 177) {
                        let code = info.code.split('')
                        code[0] = 'HK'
                        this.initChart(data.data, marketid + '_' + code.join(''))
                    } else {
                        this.initChart(data.data, marketid + '_' + info.code)
                    }
                })
            })
        },
        formatterTooltip(num, byte, unit) {
            if(unit) {
                if (unit === '手') {
                    if (num / 1e8 > 1) {
                        num = (num / 1e8).toFixed(byte) + '亿' + unit
                    } else if (num / 1e4 > 1) {
                        num = (num / 1e4).toFixed(byte) + '万' + unit
                    } else {
                        num  = (num / 1).toFixed(byte) + unit
                    }
                } else {
                    num = (num*1).toFixed(byte) + unit
                }
            } else {
                if (num / 1e8 > 1 || num / 1e8 < -1) {
                    num = (num / 1e8).toFixed(byte) + '亿'
                } else if (num / 1e4 > 1 || num / 1e4 < -1) {
                    num = (num / 1e4).toFixed(byte) + '万'
                } else {
                    num  = (num / 1).toFixed(byte)
                }
            }
            return num
        },
        initChart(data, code) {
            let el = this.$refs.compose
            let chart = window.echarts.init(el)
            let date = data.date // 横坐标数据
            // let startTime = date[0].replace(/-/ig, '')
            // let endTime = date[date.length - 1].replace(/-/ig, '')
            let kLineLast = {
                type: 'klineLast',
                code: code,
                ma: [5, 10, 30],
                lastDays: 500
            }
            let klineLastProvider = window.D3Charts.getDataPool().register(kLineLast)
            window.D3Charts.getDataPool().onAction(klineLastProvider, 'PROVIDER_UPDATE.myproject', (d) => {
                if (d.fetchStatus.code !== '000') return
                this.stockname = d.data.name
                let hqData = d.data.dataArray
                // let startIndex
                // let endIndex
                
                // hqData.map((item, index) => {
                //     if (item.t === startTime) {
                //         startIndex = index
                //     }
                //     if (item.t === endTime) {
                //         endIndex = index
                //     }
                // })
                // hqData = hqData.slice(startIndex, endIndex + 1)
                let kData = []
                let m05 = []
                let m10 = []
                let m30 = []
                let volumes = []
                let yc = []
                let _date = []
                let zjlr = []
                let cgl = []
                let cgbl = []
                hqData.map(item => {
                    if (date.indexOf(item.t.replace(/^(\d{4})(\d{2})(\d{2})$/,  "$1-$2-$3")) !== -1) {
                        let itemDate = item.t.replace(/^(\d{4})(\d{2})(\d{2})$/,  "$1-$2-$3");
                        _date.push(itemDate);
                        yc.push(item.yc)
                        m05.push(item.ma5)
                        m10.push(item.ma10)
                        m30.push(item.ma30)
                        volumes.push(item.n / 100)
                        kData.push([
                            item.o, // 开盘价
                            item.c,// 收盘价
                            item.i,// 最低价
                            item.a,// 最高价
                        ])
                        let index = date.indexOf(itemDate)
                        zjlr.push(data.jlr[index])                       
                        cgl.push(data.cgl[index])
                        cgbl.push(data.cgbl[index])
                    }
                })
                
                chart.setOption({
                    legend: {
                        show: false
                    },
                    axisPointer: {
                        link: {xAxisIndex: 'all'}
                    },
                    animation: false,
                    tooltip: {
                        trigger: 'axis',
                        formatter: (p) => {
                            let i = p[0].dataIndex
                            this.curTime = _date[i]
                            this.open = this.formatterTooltip(kData[i][0], 2)
                            this.close = this.formatterTooltip(kData[i][1], 2)
                            this.cjl = this.formatterTooltip(volumes[i], 2, '手')
                            this.zjlr = data.jlr[i] !== '--' ? this.formatterTooltip(zjlr[i], 2) : '--'
                            this.cgl = data.cgl[i] !== '--' ? this.formatterTooltip(cgl[i], 2) : '--'
                            this.cgbl = data.cgbl[i] !== '--' ? this.formatterTooltip(cgbl[i], 2, '%') : '--'
                            // hover 埋点  只发一次
                            if (this.statFlag) {
                                window.TA.log({
                                    id: `webhsgt_zjlx_hover`
                                })
                                this.statFlag = false
                            }
                            this.yc = yc[i]
                            return `<div>
                                <div>${this.curTime}</div>
                                <div>开盘价:<span class="${this.open>this.yc?'up':'down'}">${this.open}</span></div>
                                <div>最高价:<span class="${kData[i][3]>this.yc?'up':'down'}">${this.formatterTooltip(kData[i][3], 2)}</span></div>
                                <div>最低价:<span class="${kData[i][2]>this.yc?'up':'down'}">${this.formatterTooltip(kData[i][2], 2)}</span></div>
                                <div>收盘价:<span class="${this.close>this.yc?'up':'down'}">${this.close}</span></div>
                            </div>`
                        },
                        position: ['60%', 100],
                    },
                    grid: [
                        {
                            height: '150px',
                            top: 28,
                            left: 50,
                            right: 8,
                            borderColor: '#343434',
                            containLabel: false,
                            show: true,
                        }, 
                        {
                            height: '70px',
                            top: 220,
                            left: 50,
                            right: 8,
                            borderColor: '#343434',
                            containLabel: false,
                            show: true,
                        }, 
                        {
                            height: '140px',
                            top: 340,
                            left: 50,
                            right: 8,
                            borderColor: '#343434',
                            containLabel: false,
                            show: true
                        }, 
                        {
                            height: '100px',
                            top: 520,
                            left: 50,
                            right: 8,
                            borderColor: '#343434',
                            containLabel: false,
                            show: true
                        }
                    ],
                    xAxis: [
                        {
                            gridIndex: 0,
                            type: 'category',
                            show: false,
                            data: _date,
                            axisTick: { show: false },
                            axisPointer: {
                                show: true,
                                type: 'line',
                                label: {
                                    show: true,
                                    formatter: function(p) {
                                        return p.value
                                    },
                                    fontFamily: 'SimSun'
                                }
                            },
                        }, 
                        {
                            gridIndex: 1,
                            type: 'category',
                            show: false,
                            data: _date,
                            axisTick: { show: false },
                            axisPointer: {
                                show: true,
                                type: 'line',
                                label: {
                                    show: true,
                                    formatter: function(p) {
                                        return p.value
                                    },
                                    fontFamily: 'SimSun'
                                }
                            },
                        }, 
                        {
                            gridIndex: 2,
                            type: 'category',
                            show: false,
                            data: _date,
                            axisTick: { show: false },
                            axisPointer: {
                                show: true,
                                type: 'line',
                                label: {
                                    show: true,
                                    formatter: function(p) {
                                        return p.value
                                    },
                                    fontFamily: 'SimSun'
                                }
                            },
                        }, 
                        {
                            gridIndex: 3,
                            type: 'category',
                            data: _date,
                            axisTick: { show: false },
                            axisLabel: {
                                color: '#bfbfbf',
                                fontFamily: 'SimSun',
                                align: 'right',
                                formatter: function(value, index) {
                                    return index ? value : ''
                                }
                            },
                            axisPointer: {
                                show: true,
                                type: 'line',
                                label: {
                                    show: true,
                                    formatter: function(p) {
                                        return p.value
                                    },
                                    fontFamily: 'SimSun'
                                }
                            },
                        }
                    ],
                    yAxis: [
                        {
                            gridIndex: 0,
                            axisTick: { show: false },
                            axisLine: { show: false},
                            splitLine: { show: false },
                            axisLabel: {
                                color: '#aaaaaa',
                                fontSize: 12,
                                fontFamily: 'SimSun',
                                formatter: (value, index) => {
                                    if (index !== 0) {
                                        return value + ''
                                    }
                                },
                            },
                            // axisPointer: { show: true },
                            min: function(v) {
                                return ~~v.min
                            }
                        }, {
                            gridIndex: 1,
                            axisTick: { show: false },
                            axisLine: { show: false},
                            splitLine: { show: false },
                            axisLabel: {
                                color: '#aaaaaa',
                                fontFamily: 'SimSun',
                                formatter: (value, index) => {
                                    if (index&1) {
                                        if (value/1e8>=1||value/1e8<=-1) {
                                            return value/1e8 + '亿'
                                        } else if (value/1e4>=1||value/1e4<=-1) {
                                            return value/1e4 + '万'
                                        } else {
                                            return value
                                        }
                                    }
                                },
                                fontSize: 12
                            },
                        }, {
                            gridIndex: 2,
                            axisTick: { show: false },
                            axisLine: { show: false},
                            splitLine: { show: false },
                            axisLabel: {
                                color: '#aaaaaa',
                                fontFamily: 'SimSun',
                                formatter: (value, index) => {
                                    if (index&1) {
                                        if (value/1e8>=1||value/1e8<=-1) {
                                            return value/1e8 + '亿'
                                        } else if (value/1e4>=1||value/1e4<=-1) {
                                            return value/1e4 + '万'
                                        } else {
                                            return value
                                        }
                                    }
                                },
                                fontSize: 12
                            },
                            /* axisPointer: {
                                show: true,
                                label: {
                                    formatter: function(param) {
                                        let res
                                        let p = param.value
                                        if (p/1e8>=1 || p/1e8<=-1) {
                                            res = (p/1e8).toFixed(0) + '亿'
                                        } else if(p/1e4>=1 || p/1e4<=-1) {
                                            res = (p/1e4).toFixed(0) + '万'
                                        } else {
                                            res = (p*1).toFixed(0)
                                        }
                                        return res
                                    }
                                }
                            }, */
                        }, {
                            gridIndex: 3,
                            axisTick: { show: false },
                            axisLine: { show: false},
                            splitLine: { show: false },
                            axisLabel: {
                                color: '#aaaaaa',
                                fontFamily: 'SimSun',
                                formatter: (value, index) => {
                                    if (index&1) {
                                        if (value/1e8>=1||value/1e8<=-1) {
                                            return value/1e8 + '亿'
                                        } else if (value/1e4>=1||value/1e4<=-1) {
                                            return value/1e4 + '万'
                                        } else {
                                            return value
                                        }
                                    }
                                },
                                fontSize: 12,
                                /* axisPointer: {
                                    show: true,
                                    label: {
                                        formatter: function(param) {
                                            let res
                                            let p = param.value
                                            if (p/1e8>=1 || p/1e8<=-1) {
                                                res = (p/1e8).toFixed(0) + '亿'
                                            } else if(p/1e4>=1 || p/1e4<=-1) {
                                                res = (p/1e4).toFixed(0) + '万'
                                            } else {
                                                res = (p*1).toFixed(0)
                                            }

                                            return res
                                        }
                                    }
                                }, */
                            },
                        }, {
                            gridIndex: 3,
                            axisTick: { show: false },
                            axisLine: { show: false},
                            splitLine: { show: false },
                            axisLabel: { show: false },
                        }
                    ],
                    dataZoom: [
                        {
                            type: 'inside',
                            xAxisIndex: [0, 1, 2, 3],
                            start: 80,
                            end: 100
                        },
                        {
                            show: false,
                            xAxisIndex: [0, 1, 2, 3],
                            type: 'slider',
                            start: 80,
                            end: 100,
                            realtime: true
                        }
                    ],
                    series: [
                        {
                            type: 'candlestick',
                            data: kData,
                            itemStyle: {
                                color: '#e9524d',
                                color0: '#279e64',
                                borderColor: null,
                                borderColor0: null
                            },
                            symbol: 'none',
                        }, 
                        {
                            type: 'line',
                            data: m05,
                            symbol: 'none',
                            lineStyle: {
                                width: 1
                            }
                        }, 
                        {
                            type: 'line',
                            data: m10,
                            symbol: 'none',
                            lineStyle: {
                                width: 1
                            }
                        }, 
                        {
                            type: 'line',
                            data: m30,
                            symbol: 'none',
                            lineStyle: {
                                width: 1
                            }
                        }, 
                        {
                            name: '成交量',
                            type: 'bar',
                            data: volumes, 
                            xAxisIndex: 1,
                            yAxisIndex: 1,
                            symbol: 'none',
                            itemStyle: {
                                color: (p) => {
                                    let i = p.dataIndex
                                    return kData[i][0] > kData[i][1] ? '#279e64' : '#e9524d'
                                }
                            }
                        }, 
                        {
                            name: '资金流入',
                            type: 'bar',
                            symbol: 'none',
                            // data: data.jlr,
                            data: zjlr,
                            xAxisIndex: 2,
                            yAxisIndex: 2,
                            itemStyle: {
                                color: function(d) {
                                    return d.value > 0 ? '#e9524d' : '#279e64'
                                }
                            }
                        }, 
                        {
                            name: '持股量',
                            type: 'bar',
                            // data: data.cgl,
                            data: cgl,
                            xAxisIndex: 3,
                            yAxisIndex: 3,
                            symbol: 'none',
                            itemStyle: {
                                color: '#56b0f4'
                            }
                        }, 
                        {
                            name: '持股比例',
                            type: 'line',
                            // data: data.cgbl,
                            data: cgbl,
                            xAxisIndex: 3,
                            yAxisIndex: 4,
                            symbol: 'none',
                            itemStyle: {
                                color: '#f2fa90'
                            },
                            lineStyle: {
                                width: 1
                            }
                        }
                    ]
                })
                chart.on('datazoom', () => {
                    window.TA.log({
                        id: `webhsgt_zjlx_drag`
                    })
                })
            })
        }
    }
}
</script>

<style lang="less">
.compose-chart-wrap {
    height: 648px;
    position: relative;
    font-size: 12px;
    line-height: 22px;
    color: #bfbfbf;
    .compose-chart {
        height: 648px;
        width: 100%;
    }
    .k-line-tol {
        top: 0;
        left: 50px;
        .zjlx-time {
            margin-right: 10px;
        }
        .zjlx-kpj, .zjlx-spj {
            margin-left: 10px;
        }
    }
    .cjl-tol {
        top: 200px;
        left: 50px;
    }
    .zjlr-tol {
        top: 320px;
        left: 50px;
    }
    .cg-detail-tol {
        top: 500px;
        left: 50px;
    }
}
.newblack .cg-detail-tol span:nth-child(2){
    color: #272841 !important;
}
.newblack .zjlr-tol span{
    color: #272841 !important;
}
.newblack .cjl-tol span{
    color: #272841 !important;
}

</style>
